module.exports = __webpack_public_path__ + "static/media/money_train_2.relax.2218282d.jpeg";